exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-control[data-v-6ed45e64]{background-color:#fff;border:2px solid #5451de}.form-control[data-v-6ed45e64]:disabled{background-color:rgba(110,107,248,.14901960784313725)!important}", ""]);

// exports
